import { IState } from 'shared/store';

export const selectBestPlaceAnalyticsAvailable = (state: IState) => {
  return state.offerData.offer.bestPlaceAnalyticsAvailable;
};
